// src/i18n/locales/ru.js

export default {
  countries: {
    'AF': 'Афганистан',
    'AL': 'Албания',
    'DZ': 'Алжир',
    'AD': 'Андорра',
    'AO': 'Ангола',
    'AG': 'Антигуа и Барбуда',
    'AR': 'Аргентина',
    'AM': 'Армения',
    'AU': 'Австралия',
    'AT': 'Австрия',
    'AZ': 'Азербайджан',
    'BS': 'Багамы',
    'BH': 'Бахрейн',
    'BD': 'Бангладеш',
    'BB': 'Барбадос',
    'BY': 'Беларусь',
    'BE': 'Бельгия',
    'BZ': 'Белиз',
    'BJ': 'Бенин',
    'BT': 'Бутан',
    'BO': 'Боливия',
    'BA': 'Босния и Герцеговина',
    'BW': 'Ботсвана',
    'BR': 'Бразилия',
    'BN': 'Бруней',
    'BG': 'Болгария',
    'BF': 'Буркина-Фасо',
    'BI': 'Бурунди',
    'CV': 'Кабо-Верде',
    'KH': 'Камбоджа',
    'CM': 'Камерун',
    'CA': 'Канада',
    'CF': 'Центральноафриканская Республика',
    'TD': 'Чад',
    'CL': 'Чили',
    'CN': 'Китай',
    'CO': 'Колумбия',
    'KM': 'Коморы',
    'CG': 'Конго',
    'CD': 'Конго, Демократическая Республика',
    'CR': 'Коста-Рика',
    'CI': 'Кот-д’Ивуар',
    'HR': 'Хорватия',
    'CU': 'Куба',
    'CY': 'Кипр',
    'CZ': 'Чехия',
    'DK': 'Дания',
    'DJ': 'Джибути',
    'DM': 'Доминика',
    'DO': 'Доминиканская Республика',
    'EC': 'Эквадор',
    'EG': 'Египет',
    'SV': 'Сальвадор',
    'GQ': 'Экваториальная Гвинея',
    'ER': 'Эритрея',
    'EE': 'Эстония',
    'ET': 'Эфиопия',
    'FJ': 'Фиджи',
    'FI': 'Финляндия',
    'FR': 'Франция',
    'GA': 'Габон',
    'GM': 'Гамбия',
    'GE': 'Грузия',
    'DE': 'Германия',
    'GH': 'Гана',
    'GR': 'Греция',
    'GD': 'Гренада',
    'GT': 'Гватемала',
    'GN': 'Гвинея',
    'GW': 'Гвинея-Бисау',
    'GY': 'Гайана',
    'HT': 'Гаити',
    'HN': 'Гондурас',
    'HU': 'Венгрия',
    'IS': 'Исландия',
    'IN': 'Индия',
    'ID': 'Индонезия',
    'IR': 'Иран',
    'IQ': 'Ирак',
    'IE': 'Ирландия',
    'IL': 'Израиль',
    'IT': 'Италия',
    'JM': 'Ямайка',
    'JP': 'Япония',
    'JO': 'Иордания',
    'KZ': 'Казахстан',
    'KE': 'Кения',
    'KI': 'Кирибати',
    'KP': 'КНДР',
    'KR': 'Южная Корея',
    'KW': 'Кувейт',
    'KG': 'Кыргызстан',
    'LA': 'Лаос',
    'LV': 'Латвия',
    'LB': 'Ливан',
    'LS': 'Лесото',
    'LR': 'Либерия',
    'LY': 'Ливия',
    'LI': 'Лихтенштейн',
    'LT': 'Литва',
    'LU': 'Люксембург',
    'MG': 'Мадагаскар',
    'MW': 'Малави',
    'MY': 'Малайзия',
    'MV': 'Мальдивы',
    'ML': 'Мали',
    'MT': 'Мальта',
    'MH': 'Маршалловы Острова',
    'MR': 'Мавритания',
    'MU': 'Маврикий',
    'MX': 'Мексика',
    'FM': 'Микронезия',
    'MD': 'Молдова',
    'MC': 'Монако',
    'MN': 'Монголия',
    'ME': 'Черногория',
    'MA': 'Марокко',
    'MZ': 'Мозамбик',
    'MM': 'Мьянма',
    'NA': 'Намибия',
    'NR': 'Науру',
    'NP': 'Непал',
    'NL': 'Нидерланды',
    'NZ': 'Новая Зеландия',
    'NI': 'Никарагуа',
    'NE': 'Нигер',
    'NG': 'Нигерия',
    'MK': 'Северная Македония',
    'NO': 'Норвегия',
    'OM': 'Оман',
    'PK': 'Пакистан',
    'PW': 'Палау',
    'PS': 'Палестина',
    'PA': 'Панама',
    'PG': 'Папуа — Новая Гвинея',
    'PY': 'Парагвай',
    'PE': 'Перу',
    'PH': 'Филиппины',
    'PL': 'Польша',
    'PT': 'Португалия',
    'QA': 'Катар',
    'RO': 'Румыния',
    'RU': 'Россия',
    'RW': 'Руанда',
    'KN': 'Сент-Китс и Невис',
    'LC': 'Сент-Люсия',
    'VC': 'Сент-Винсент и Гренадины',
    'WS': 'Самоа',
    'SM': 'Сан-Марино',
    'ST': 'Сан-Томе и Принсипи',
    'SA': 'Саудовская Аравия',
    'SN': 'Сенегал',
    'RS': 'Сербия',
    'SC': 'Сейшелы',
    'SL': 'Сьерра-Леоне',
    'SG': 'Сингапур',
    'SK': 'Словакия',
    'SI': 'Словения',
    'SB': 'Соломоновы Острова',
    'SO': 'Сомали',
    'ZA': 'Южная Африка',
    'SS': 'Южный Судан',
    'ES': 'Испания',
    'LK': 'Шри-Ланка',
    'SD': 'Судан',
    'SR': 'Суринам',
    'SZ': 'Эсватини',
    'SE': 'Швеция',
    'CH': 'Швейцария',
    'SY': 'Сирия',
    'TJ': 'Таджикистан',
    'TZ': 'Танзания',
    'TH': 'Таиланд',
    'TL': 'Восточный Тимор',
    'TG': 'Того',
    'TO': 'Тонга',
    'TT': 'Тринидад и Тобаго',
    'TN': 'Тунис',
    'TR': 'Турция',
    'TM': 'Туркменистан',
    'TV': 'Тувалу',
    'UG': 'Уганда',
    'UA': 'Украина',
    'AE': 'Объединённые Арабские Эмираты',
    'GB': 'Великобритания',
    'US': 'Соединённые Штаты',
    'UY': 'Уругвай',
    'UZ': 'Узбекистан',
    'VU': 'Вануату',
    'VA': 'Ватикан',
    'VE': 'Венесуэла',
    'VN': 'Вьетнам',
    'YE': 'Йемен',
    'ZM': 'Замбия',
    'ZW': 'Зимбабве'
  },
  verification: {
    verifying: 'Проверка вашей электронной почты...',
    success: 'Электронная почта успешно подтверждена!',
    failed: 'Ошибка проверки',
    accountVerified: 'Ваша учётная запись успешно подтверждена. Теперь вы можете войти в свою учётную запись.',
    invalidLink: 'Ссылка для проверки недействительна или истекла.',
    missingToken: 'Отсутствует токен проверки.',
    generalError: 'Произошла ошибка во время проверки. Пожалуйста, попробуйте снова позже.',
    proceedToLogin: 'Перейти к входу',
    backToLogin: 'Вернуться к входу'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Панель управления',
    system: 'Система',
    settings: 'Настройки',
    overview: 'Обзор',
    database: 'База данных',
    logs: 'Журналы',
    userManagement: 'Управление пользователями',
    security: 'Безопасность',
    systemAdministration: 'Администрирование системы',
    loading: 'Загрузка...',
    close: 'Закрыть панель управления',
    edit: 'Редактировать',
    systemUptime: 'Время работы системы',
    avgResponseTime: 'Среднее время ответа',
    errorRate: 'Уровень ошибок',
    activeUsers: 'Активные пользователи',
    monthlyActiveUsers: 'Ежемесячные активные пользователи (MAU)',
    fromLastMonth: 'с прошлого месяца',
    today: 'Сегодня',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'Состояние системы',
      hierarchy: 'Иерархия знаний', // NEW
      documents: 'Управление документами', // NEW
      database: 'База данных',
      logs: 'Журналы',
      security: 'Безопасность',
      users: 'Пользователи'
    },
    // --- NEW KEYS ---
    contentManagement: "УПРАВЛЕНИЕ КОНТЕНТОМ",
    knowledgeHierarchy: "Иерархия знаний",
    documentManagement: "Управление документами",
    noLogsFound: "Журналы за сегодня не найдены",
    invalidLogsResponse: "Недопустимая структура ответа сводки журналов",
    logsSummaryError: "Не удалось загрузить сводку журналов",
    buttons: {
      save: "Сохранить",
      cancel: "Отмена",
      switch: "Все равно переключить",
      discard: "Отменить"
    },
    confirm: {
      defaultTitle: "Подтвердить",
      defaultMessage: "Вы уверены?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Статус состояния системы',
    runDiagnostics: 'Запустить диагностику',
    resourceUsage: 'Использование ресурсов',
    services: {
      apiServices: 'Службы API',
      database: 'База данных',
      cache: 'Кэш',
      storage: 'Хранилище',
      messageQueue: 'Очередь сообщений',
      externalApi: 'Внешний API'
    },
    resources: {
      cpu: 'Использование процессора',
      memory: 'Использование памяти',
      storage: 'Использование хранилища',
      network: 'Пропускная способность сети'
    },
    databaseManagement: 'Управление базой данных',
    reindexDatabase: 'Переиндексировать базу данных',
    lastReindex: 'Последняя переиндексация',
    databaseSize: 'Размер базы данных',
    totalTables: 'Всего таблиц',
    logManagement: 'Управление журналами',
    rolloverLogs: 'Ротация журналов',
    searchLogs: 'Поиск в журналах',
    logTime: 'Время',
    logLevel: 'Уровень',
    logService: 'Служба',
    logMessage: 'Сообщение',
    showingEntries: 'Показано {start}-{end} из {total} записей',
    logLevels: {
      error: 'ОШИБКА',
      warn: 'ПРЕДУПРЕЖДЕНИЕ',
      info: 'ИНФО',
      debug: 'ОТЛАДКА'
    },
    logMessages: {
      connectionTimeout: 'Тайм-аут соединения с внешним провайдером',
      lowDiskSpace: 'Место на диске ниже порога 10%',
      userRoleUpdated: 'Роль пользователя обновлена для admin@huduma.ai'
    },
    userName: 'Имя',
    userEmail: 'Электронная почта',
    userRole: 'Роль',
    userStatus: 'Статус',
    userActions: 'Действия',
    roleAdministrator: 'Администратор',
    roleUser: 'Пользователь',
    statusActive: 'Активен',
    dbActions: {
      reindex: 'Переиндексировать',
      backup: 'Резервное копирование',
      optimize: 'Оптимизировать',
      reindexDesc: 'Перестроить индексы базы данных',
      backupDesc: 'Создать резервную копию базы данных',
      optimizeDesc: 'Оптимизировать производительность запросов'
    },
    operations: {
      reindexTitle: 'Результаты переиндексации базы данных',
      backupTitle: 'Результаты резервного копирования базы данных',
      optimizeTitle: 'Результаты оптимизации базы данных',
      reindexResults: 'Результаты переиндексации',
      optimizeResults: 'Результаты оптимизации',
      collection: 'Коллекция',
      status: 'Статус',
      indexSuggestions: 'Предложения по индексам',
      backupDetails: 'Детали резервного копирования',
      backupFile: 'Файл резервной копии',
      backupLocation: 'Местоположение',
      backupSize: 'Размер',
      errorDetails: 'Детали ошибки',
      close: 'Закрыть',
      resultsTitle: 'Результаты операции',
      reindexDatabase: {
        success: 'Переиндексация базы данных успешно завершена',
        error: 'Ошибка при переиндексации базы данных',
        loading: 'Переиндексация базы данных...'
      },
      backupDatabase: {
        success: 'Резервное копирование базы данных успешно завершено',
        error: 'Ошибка при резервном копировании базы данных',
        loading: 'Резервное копирование базы данных...'
      },
      optimizeDatabase: {
        success: 'Оптимизация базы данных успешно завершена',
        error: 'Ошибка при оптимизации базы данных',
        loading: 'Оптимизация базы данных...'
      },
      rolloverLogs: {
        success: 'Ротация журналов успешно завершена',
        loading: 'Ротация журналов...'
      },
      searchLogs: {
        success: 'Поиск в журналах завершен',
        loading: 'Поиск в журналах...'
      },
      runDiagnostics: {
        success: 'Диагностика успешно завершена',
        loading: 'Выполняется диагностика...'
      },
      runSecurityScan: {
        success: 'Сканирование безопасности успешно завершено',
        loading: 'Выполняется сканирование безопасности...'
      },
      cancel: 'Отмена',
      save: 'Сохранить изменения'
    },
    userManagementSection: {
      totalUsers: 'Всего пользователей',
      newUsers: 'Новые пользователи (месяц)',
      searchUsers: 'Поиск пользователей...',
      clearSearch: 'Очистить поиск',
      search: 'Поиск',
      usersFound: 'пользователей найдено',
      showAllUsers: 'Показать всех пользователей',
      searching: 'Поиск...',
      searchingUsers: 'Поиск пользователей...',
      noUsersFound: 'Пользователи, соответствующие критериям поиска, не найдены.',
      noUsers: 'Нет доступных пользователей.',
      showing: 'Показано',
      of: 'из',
      previous: 'Предыдущая',
      next: 'Следующая',
      searchFields: {
        all: 'Все поля',
        name: 'Имя',
        email: 'Электронная почта',
        role: 'Роль'
      },
      userSearch: {
        resultsFound: 'Найдено {total} пользователей, соответствующих "{term}"',
        error: 'Ошибка при поиске пользователей'
      }
    },
    logsSection: {
      errorLogs: 'Журналы ошибок',
      warningLogs: 'Журналы предупреждений',
      noErrorLogs: 'Сегодня не зарегистрировано журналов ошибок.',
      noWarningLogs: 'Сегодня не зарегистрировано журналов предупреждений.',
      infoLogsNote: 'Информационные журналы не отображаются в сводке. Используйте функцию поиска, чтобы просмотреть все типы журналов.',
      searchResults: 'Последние результаты поиска',
      entriesFound: 'записей найдено',
      viewAllResults: 'Просмотреть все результаты',
      logType: 'Тип',
      logCount: 'Количество',
      logTypes: {
        connectionTimeout: 'Тайм-аут соединения',
        databaseFailed: 'Ошибка запроса к базе данных',
        authFailed: 'Ошибка аутентификации',
        lowDiskSpace: 'Место на диске ниже порога',
        slowQuery: 'Низкая производительность запроса',
        rateLimit: 'Приближение к лимиту скорости'
      },
      logSearch: {
        noResultsFound: 'Не найдено журналов, соответствующих вашим критериям поиска',
        resultsFound: 'Найдено {count} записей журнала'
      }
    },
    security: {
      title: 'Мониторинг безопасности',
      securityScan: 'Сканирование безопасности',
      runningSecurityScan: 'Выполняется сканирование...',
      lastSecurityScan: 'Последнее сканирование безопасности',
      vulnerabilitiesFound: 'Обнаруженные уязвимости',
      daysAgo: 'дней назад',
      critical: 'критический',
      medium: 'средний',
      low: 'низкий',
      failedLoginAttempts: 'Неуспешные попытки входа (24ч)',
      suspiciousActivities: 'Подозрительные действия (24ч)',
      securityRecommendations: 'Рекомендации по безопасности',
      criticalVulnerabilities: 'Критические уязвимости',
      mediumVulnerabilities: 'Средние уязвимости',
      lowVulnerabilities: 'Низкие уязвимости',
      authenticationIssues: 'Проблемы аутентификации',
      suspiciousActivityLogs: 'Журналы подозрительных действий',
      securityProbeAttempts: 'Обнаружены попытки зондирования безопасности',
      sensitiveFileAccess: 'обнаружены попытки доступа к конфиденциальным файлам или конечным точкам',
      envFileAccess: 'Попытки доступа к файлам окружения',
      envFileAccessDesc: 'обнаружены попытки доступа к файлам .env',
      gitRepoAccess: 'Попытки доступа к репозиторию Git',
      gitRepoAccessDesc: 'обнаружены попытки доступа к файлам репозитория Git',
      recommendedAction: 'Рекомендуемое действие',
      rateLimitRecommendation: 'Рассмотрите внедрение ограничения скорости, блокировку IP-адресов для постоянных нарушителей и убедитесь, что сервер должным образом защищён.',
      envFileRecommendation: 'Убедитесь, что файлы окружения недоступны из веб-каталогов, и серверные конфигурации должным образом блокируют доступ к конфиденциальным файлам.',
      gitRepoRecommendation: 'Убедитесь, что каталоги .git должным образом защищены и недоступны из веб.',
      noVulnerabilitiesFound: 'Уязвимости не найдены',
      systemSecure: 'Ваша система выглядит безопасной. Продолжайте регулярно отслеживать.',
      loadingScan: 'Загрузка результатов сканирования...',
      occurrences: 'Случаи',
      firstSeen: 'Впервые замечено',
      lastSeen: 'Последний раз замечено',
      timestamp: 'Временная метка',
      message: 'Сообщение',
      service: 'Служба',
      type: 'Тип',
      severity: 'Серьёзность',
      url: 'URL',
      matchedTerm: 'Соответствующий термин',
      lineNumber: 'Номер строки',
      lineNumbers: 'Номера строк',
      showLess: 'Показать меньше',
      showMore: 'Показать все проблемы',
      // --- NEW KEY ---
      lastScanJustNow: "Только что"
    },
    userEdit: {
      title: 'Редактировать пользователя',
      loading: 'Загрузка данных пользователя...',
      userInfo: 'Информация о пользователе',
      userId: 'ID пользователя',
      loginName: 'Имя для входа',
      fullName: 'Полное имя',
      dob: 'Дата рождения',
      email: 'Электронная почта',
      emailVerified: 'Электронная почта подтверждена',
      verified: 'Подтверждено',
      notVerified: 'Не подтверждено',
      createdAt: 'Создано',
      lastLogin: 'Последний вход',
      never: 'Никогда',
      accountSettings: 'Настройки учётной записи',
      accountStatus: 'Статус учётной записи',
      accountEnabled: 'Учётная запись активна',
      cannotDisableSelf: 'Вы не можете отключить собственную учётную запись',
      accountRole: 'Роль учётной записи',
      adminRole: 'Роль администратора',
      cannotChangeOwnRole: 'Вы не можете изменить собственную роль',
      adminActions: 'Действия администратора',
      verifyEmail: 'Подтвердить электронную почту',
      resetPassword: 'Отправить сброс пароля',
      forceLogout: 'Принудительный выход',
      failedToLoad: 'Не удалось загрузить данные пользователя',
      errorLoading: 'Ошибка загрузки данных пользователя',
      saveSuccess: 'Настройки пользователя успешно обновлены',
      errorSaving: 'Ошибка сохранения настроек пользователя',
      verifyEmailSuccess: 'Письмо для подтверждения успешно отправлено',
      emailVerificationFailed: 'Не удалось отправить письмо для подтверждения',
      errorVerifyingEmail: 'Ошибка при отправке письма для подтверждения',
      passwordResetSent: 'Письмо для сброса пароля отправлено',
      passwordResetFailed: 'Не удалось отправить сброс пароля',
      errorSendingReset: 'Ошибка при отправке сброса пароля',
      logoutForced: 'Пользователь был принудительно выведен из системы',
      logoutFailed: 'Не удалось принудительно вывести из системы',
      errorForcingLogout: 'Ошибка при принудительном выходе',
      // --- NEW KEY ---
      userUpdated: "Пользователь успешно обновлен"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Управление иерархией знаний (примечание: всегда на английском - добавить переводы)",
      addCategory: "Добавить новую категорию",
      loading: "Загрузка иерархии...",
      addService: "Добавить услугу",
      editCategory: "Редактировать категорию",
      deleteCategory: "Удалить категорию",
      editService: "Редактировать услугу",
      deleteService: "Удалить услугу",
      empty: 'Категории не найдены. Нажмите "Добавить новую категорию", чтобы начать.',
      formTitleCreateCategory: "Создать новую категорию",
      formTitleAddService: 'Добавить услугу в "{categoryName}"',
      formTitleEditCategory: 'Редактировать категорию: "{itemName}"',
      formTitleEditService: 'Редактировать услугу: "{itemName}"',
      nameEnLabel: "Название (Английский)",
      translationsTitle: "Переводы для отображения",
      loadingTranslations: "Загрузка переводов...",
      selectLang: "Выберите язык",
      translationPlaceholder: "Введите перевод",
      deleteTranslation: "Удалить перевод",
      addTranslation: "+ Добавить перевод",
      saveSuccess: "Элемент иерархии успешно сохранен.",
      saveError: "Не удалось сохранить элемент иерархии.",
      loadError: "Не удалось загрузить иерархию знаний.",
      loadTranslationsError: "Не удалось загрузить переводы.",
      confirmCancelTitle: "Несохраненные изменения",
      confirmCancelEdit: "У вас есть несохраненные изменения. Вы уверены, что хотите отменить?",
      confirmDeleteTitleCategory: "Удалить категорию?",
      confirmDeleteTitleService: "Удалить услугу?",
      confirmDeleteCategory: 'Вы уверены, что хотите удалить категорию "{itemName}"? Это действие необратимо.',
      confirmDeleteService: 'Вы уверены, что хотите удалить услугу "{itemName}"? Это действие необратимо.',
      deleteSuccessCategory: "Категория успешно удалена.",
      deleteSuccessService: "Услуга успешно удалена.",
      deleteErrorCategory: "Не удалось удалить категорию.",
      deleteErrorService: "Не удалось удалить услугу.",
      duplicateLangError: "В переводах найдены дублирующиеся языки. Пожалуйста, удалите их."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Управление документами",
      addLink: "Добавить по ссылке",
      uploadFiles: "Загрузить файлы",
      searchPlaceholder: "Поиск по имени файла...",
      allStatuses: "Все статусы",
      statusPending: "Ожидание",
      statusIngested: "Обработано",
      statusRetracted: "Изъято",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Обрабатывается",
      statusError: "Ошибка обработки",
      statusWarning: "Обработано с предупреждениями",
      // ---
      ingestSelected: "Обработать выбранные",
      colFileName: "Имя файла",
      colStatus: "Статус",
      colLabels: "Метки",
      colUploadDate: "Дата загрузки",
      colSize: "Размер",
      loading: "Загрузка документов...",
      empty: "Документы не найдены.",
      loadError: "Не удалось загрузить документы.",
      confirmIngestTitle: "Подтвердить пакетную обработку",
      ingest: "Обработать",
      confirmIngestSelected: "Вы уверены, что хотите обработать {count} выбранный(х) файл(ов)?",
      ingestQueuedSuccess: "{count} файл(ов) добавлен(ы) в очередь на обработку.",
      ingestQueuedError: "Произошла ошибка во время процесса пакетной обработки.",
      uploadSuccessMultiple: "{count} файл(ов) успешно загружен(ы).",
      linkSubmitSuccess: 'Успешно просканировано и сохранено "{fileName}".',
      actionSuccess: 'Действие "{action}" с файлом {fileId} прошло успешно.',
      metadataUpdateSuccess: 'Метаданные для файла {fileId} обновлены.'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Создать новый пароль',
    tokenLabel: 'Токен сброса',
    tokenPlaceholder: 'Введите токен сброса',
    validateButton: 'Проверить токен',
    newPasswordLabel: 'Новый пароль',
    newPasswordPlaceholder: 'Создайте новый пароль',
    confirmNewPasswordLabel: 'Подтвердите новый пароль',
    confirmNewPasswordPlaceholder: 'Подтвердите ваш новый пароль',
    resetButton: 'Сбросить пароль',
    processing: 'Сброс...',
    rememberedPassword: 'Вспомнили пароль?',
    backToLogin: 'Вернуться к входу',
    supportMessage: 'Нужна помощь? Свяжитесь с нашей службой поддержки',
    passwordRequirements: 'Пароль должен содержать не менее 8 символов, включая как минимум 1 цифру, 1 заглавную букву и 1 специальный символ',
    passwordsDoNotMatch: 'Пароли не совпадают',
    resetSuccess: 'Ваш пароль успешно сброшен',
    resetFailed: 'Не удалось сбросить пароль. Пожалуйста, попробуйте снова.',
    noTokenProvided: 'Пожалуйста, укажите токен сброса',
    expiredToken: 'Этот токен сброса истёк. Пожалуйста, запросите новый.',
    invalidToken: 'Недействительный или нераспознанный токен сброса',
    validatingToken: 'Проверка токена...',
    redirecting: 'Перенаправление на страницу входа...',
    passwordStrength: 'Надёжность пароля',
    strengthLabels: {
      veryWeak: 'Очень слабый',
      weak: 'Слабый',
      fair: 'Средний',
      good: 'Хороший',
      strong: 'Сильный'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Используйте не менее 8 символов',
      addUppercase: 'Добавьте заглавные буквы',
      addLowercase: 'Добавьте строчные буквы',
      addNumbers: 'Добавьте цифры',
      addSpecialChars: 'Добавьте специальные символы'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Сбросить пароль',
    emailLabel: 'Адрес электронной почты',
    emailPlaceholder: 'Введите ваш email',
    resetButton: 'Отправить ссылку для сброса',
    processing: 'Отправка...',
    rememberPassword: 'Вспомнили пароль?',
    backToLogin: 'Вернуться к входу',
    supportMessage: 'Нужна помощь? Свяжитесь с нашей службой поддержки',
    invalidEmail: 'Пожалуйста, введите действительный адрес электронной почты',
    resetRequestSuccess: 'Ссылка для сброса пароля отправлена на ваш email',
    resetRequestFailed: 'Не удалось отправить ссылку для сброса пароля. Пожалуйста, попробуйте снова.',
    checkEmail: 'Пожалуйста, проверьте вашу электронную почту для дальнейших инструкций.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Создать новую учётную запись",
    username: "Имя пользователя",
    usernamePlaceholder: "Введите имя пользователя",
    email: "Электронная почта",
    emailPlaceholder: "Введите ваш email",
    password: "Пароль",
    passwordPlaceholder: "Создайте пароль",
    confirmPassword: "Подтвердите пароль",
    confirmPasswordPlaceholder: "Подтвердите ваш пароль",
    acceptTerms: "Я принимаю",
    termsOfService: "Условия использования",
    registerButton: "Создать учётную запись",
    processing: "Обработка...",
    alreadyHaveAccount: "Уже есть учётная запись?",
    loginNow: "Войти",
    privacyNotice: "Регистрируясь, вы соглашаетесь с нашими Условиями использования и Политикой конфиденциальности",
    usernameMinLength: "Имя пользователя должно содержать не менее 3 символов",
    invalidEmail: "Пожалуйста, введите действительный адрес электронной почты",
    passwordRequirements: "Пароль должен содержать не менее 8 символов, включая как минимум 1 цифру и 1 заглавную букву",
    passwordsDoNotMatch: "Пароли не совпадают",
    mustAcceptTerms: "Вы должны принять Условия использования",
    registrationFailed: "Регистрация не удалась. Пожалуйста, попробуйте снова.",
    usernameExists: "Имя пользователя уже существует",
    emailExists: "Электронная почта уже существует",
    registrationSuccess: "Регистрация успешна!",
    verificationEmailSent: "Письмо для подтверждения отправлено на {email}",
    checkEmailInstructions: "Пожалуйста, проверьте вашу электронную почту и следуйте инструкциям для подтверждения учётной записи перед входом.",
    backToLogin: "Вернуться к входу",
    noEmailReceived: "Не получили письмо?",
    resendVerification: "Отправить письмо для подтверждения повторно",
    verificationResent: "Письмо для подтверждения отправлено повторно",
    verificationResendFailed: "Не удалось отправить письмо для подтверждения повторно. Пожалуйста, попробуйте снова.",
    usernameInvalidChars: 'Имя пользователя может содержать только буквы, цифры, подчеркивания, точки и дефисы',
    networkError: 'Ошибка сети. Пожалуйста, проверьте ваше соединение и попробуйте снова.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Имя пользователя',
    password: 'Пароль',
    loginButton: 'Войти',
    or: 'или',
    savedAccounts: 'Сохранённые учётные записи',
    loginSuccess: 'Вход успешен',
    loginError: 'Ошибка входа. Пожалуйста, проверьте ваши учетные данные.',
    googleLogin: 'Продолжить с Google',
    facebookLogin: 'Продолжить с Facebook',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет учётной записи?',
    createAccount: 'Создать учётную запись',
    registerNow: "Зарегистрироваться сейчас",
    termsAndPolicy: 'Входя в систему, вы соглашаетесь с нашими Условиями использования и Политикой конфиденциальности',
    loggingIn: "Вход...",
    fieldsRequired: "Имя пользователя и пароль обязательны",
    invalidCredentials: "Недействительное имя пользователя или пароль",
    tooManyAttempts: "Слишком много попыток входа. Пожалуйста, попробуйте снова позже.",
    loginFailed: "Вход не удался. Пожалуйста, попробуйте снова.",
    oauthNotImplemented: "Социальный вход ещё не реализован",
    savedLoginNotImplemented: "Вход с сохранённой учётной записью ещё не реализован"
  },
  charts: {
    tooltip: {
      title: 'Дата',
      totalQueries: 'Всего запросов',
      uniqueUsers: 'Уникальные пользователи'
    },
    day: 'День',
    noData: 'Нет данных',
    notAvailable: 'Н/Д',
    topQueries: 'Популярные запросы',
    categoryDistribution: 'Использование по областям знаний',
    usageTrend: 'Тренд использования'
  },
  analytics: {
    title: 'Аналитика данных и инсайты',
    loading: 'Загрузка аналитических данных...',
    period: 'Период времени',
    charts: {
      satisfactionHeatmap: "Удовлетворённость по областям знаний",
      satisfactionSubtitle: "Процентные оценки с течением времени"
    },
    timePeriods: {
      week4: "4 недели назад",
      week3: "3 недели назад",
      week2: "2 недели назад",
      week1: "Прошлая неделя",
      current: "Текущий"
    },
    errors: {
      loading: "Не удалось загрузить данные об удовлетворённости. Пожалуйста, попробуйте снова.",
    },
    status: {
      loading: 'Загрузка...',
      noData: 'Нет данных за этот период',
      error: 'Ошибка загрузки аналитических данных',
      online: "Система онлайн",
      offline: "Система оффлайн",
      responseTime: "Среднее время ответа",
      queueLength: "Очередь",
      uptime: "Время работы"
    },
    periods: {
      daily: 'Ежедневно',
      weekly: 'Еженедельно',
      monthly: 'Ежемесячно',
      allTime: 'За всё время'
    },
    metrics: {
      totalQueries: 'Всего запросов',
      uniqueUsers: 'Уникальные пользователи',
      avgResponseTime: 'Среднее время ответа',
      satisfaction: 'Удовлетворённость пользователей'
    },
    table: {
      rank: 'Ранг',
      query: 'Запрос',
      count: 'Количество',
      avgTime: 'Сред. время'
    },
    chartLabels: {
      categories: 'Области',
      serviceCategories: 'Области знаний',
      byUsage: 'по использованию',
      category: 'Область'
    },
    tooltips: {
      selectPeriod: 'Выбрать период времени',
      selectDate: 'Выбрать дату',
      exportData: 'Экспортировать данные'
    },
    gauge: {
      historical: 'Исторические тренды',
      vsPrevious: 'по сравнению с предыдущим периодом',
      target: 'Цель'
    },
    ratings: {
      poor: "Плохо",
      average: "Средне",
      good: "Хорошо",
      excellent: "Отлично"
    },
    slower: 'медленнее',
    faster: 'быстрее',
    percentage: 'Процент',
    note: 'Ниже приведены статистика использования и сводки отзывов пользователей.',
    usageStats: 'Статистика использования',
    peakUsers: 'Пиковые одновременные пользователи',
    activeChats: 'Активные чаты',
    usageTrend: 'Тренд использования',
    topQueries: 'Популярные запросы',
    feedbackSamples: 'Образцы отзывов пользователей',
    close: 'Закрыть',
    chartComingSoon: 'Интерактивная визуализация графиков скоро появится...',
    retry: 'Повторить',
    dailyQueries: 'Ежедневные запросы',
    export: 'Экспортировать данные',
    dateRange: 'Диапазон дат',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    rank: 'Ранг',
    query: 'Запрос',
    count: 'Количество',
    avgTime: 'Сред. время',
    serviceUsage: 'Использование по областям знаний',
    usageTrends: 'Тренды использования',
    week: 'Прошлая неделя',
    month: 'Прошлый месяц',
    quarter: 'Прошлый квартал',
    year: 'Прошлый год',
    uniqueUsers: 'Уникальные пользователи',
    satisfactionRate: 'Уровень удовлетворённости',
    satisfactionAnalysis: 'Анализ удовлетворённости пользователей'
  },
  brandName: 'Genie AI: Ваш цифровой правительственный помощник',
  nav: {
    systemStatus: 'Статус системы',
    menu: 'Меню',
    analytics: 'Аналитика',
    userProfile: 'Профиль пользователя',
    settings: 'Настройки',
    logout: 'Выйти',
    profile: 'Мой профиль',
    toggleSidebar: 'Переключить боковую панель',
    changeLanguage: 'Изменить язык',
    administration: "Администрирование",
    languages: {
      english: 'Английский',
      french: 'Французский',
      swahili: 'Суахили'
    }
  },
  systemStatus: {
    title: 'Статус службы',
    services: 'Службы',
    operational: 'Работает',
    degraded: 'Снижено',
    outage: 'Отключение',
    allOperational: 'Все системы',
    someIssues: 'Некоторые проблемы',
    majorIssues: 'Крупные проблемы',
    checking: 'Проверка...',
    nextDeadline: 'Следующий срок',
    days: 'дней',
    viewDetails: 'Просмотреть детали'
  },
  services: {
    eCitizen: 'Портал eCitizen',
    taxFiling: 'Система подачи налогов',
    idApplication: 'Заявка на ID',
    businessReg: 'Регистрация бизнеса',
    drivingLicense: 'Водительские права'
  },
  deadlines: {
    taxFiling: 'Срок подачи налогов',
    businessRenewal: 'Продление лицензии на бизнес',
    idRenewal: 'Продление удостоверения личности',
    vehicleRegistration: 'Срок регистрации транспортного средства'
  },
  sidebar: {
    governmentServices: 'Области знаний',
    chatHistory: 'История чатов',
    searchPlaceholder: 'Поиск по областям знаний...',
    createFolder: 'Создать папку',
    editFolder: 'Редактировать папку',
    folderName: 'Имя папки',
    folderNamePlaceholder: 'Введите имя папки',
    moveChat: 'Переместить чат',
    moveChatTo: 'Переместить чат в',
    selectFolder: 'Выбрать папку',
    deleteChat: 'Удалить чат',
    deleteChatConfirm: 'Вы уверены, что хотите удалить этот чат?',
    deleteChatWarning: 'Это действие нельзя отменить.',
    renameChat: "Переименовать чат",
    chatTitle: "Название чата",
    chatTitlePlaceholder: "Введите название для этого чата",
    deleteFolder: "Удалить папку",
    deleteFolderConfirm: "Вы уверены, что хотите удалить папку '{name}'?",
    chatsMoveWarning: "Все чаты в этой папке будут перемещены в папку по умолчанию.",
    weatherTitle: "Прогноз погоды",
    weatherLoading: "Загрузка данных о погоде...",
    weatherError: "Не удалось загрузить данные о погоде. Пожалуйста, попробуйте снова.",
    weatherLocationLoading: 'Загрузка местоположения...',
    weatherErrorDefault: 'Не удалось получить данные о погоде.',
    weatherGeolocationUnsupported: 'Геолокация не поддерживается вашим браузером.',
    weatherRefresh: 'Обновить погоду',
    weatherConditions: {
      clear: 'Ясно',
      partlycloudy: 'Частично облачно',
      cloudy: 'Облачно',
      overcast: 'Пасмурно',
      rain: 'Дождь',
      shower: 'Ливень',
      thunderstorm: 'Гроза',
      snow: 'Снег'
    },
    folders: "Папки",
    emptyFolder: "Эта папка пуста. Переместите сюда беседы из меню чата.",
    title: 'Информация и ресурсы',
    noChats: 'Нет недавних чатов',
    relatedDocs: 'Связанные документы',
    noDocuments: 'Нет связанных документов',
    faq: 'Часто задаваемые вопросы',
    tab: {
      all: 'Все чаты',
      folders: 'Папки',
      starred: 'Избранные',
      archived: 'Архивированные'
    },
    savedChats: 'Сохранённые чаты',
    chats: "Чаты",
    allChats: "Все чаты",
    noFolder: "Без папки",
    starredChats: "Избранные чаты",
    archivedChats: "Архивированные чаты",
    noStarredChats: "Пока нет избранных бесед. Добавьте беседу в избранное, чтобы она появилась здесь.",
    noArchivedChats: "Пока нет архивированных бесед.",
    noSearchResults: 'Не найдено бесед для "{term}"',
    loadingChats: "Загрузка бесед...",
    errorLoadingConversations: "Не удалось загрузить беседы. Пожалуйста, попробуйте снова.",
    errorLoadingUser: "Данные пользователя неполные. Пожалуйста, перезагрузите страницу.",
    errorNoUser: "Данные пользователя отсутствуют. Пожалуйста, перезагрузите страницу.",
    retry: "Повторить",
    message: "сообщение",
    messages: "сообщения",
    created: "Создано",
    updated: "Обновлено",
    star: "Добавить в избранное",
    unstar: "Убрать из избранного",
    archive: "Архивировать",
    chatStarred: "Беседа добавлена в избранное",
    chatUnstarred: "Беседа убрана из избранного",
    chatArchived: "Беседа архивирована",
    chatUnarchived: "Беседа разархивирована",
    errorUpdatingChat: "Ошибка обновления беседы",
    chatRenamed: "Беседа успешно переименована",
    errorRenamingChat: "Ошибка переименования беседы",
    chatDeleted: "Беседа успешно удалена",
    errorDeletingChat: "Ошибка удаления беседы",
    chatMoved: "Беседа успешно перемещена",
    errorMovingChat: "Ошибка перемещения беседы",
    noPreview: "Предпросмотр недоступен",
    searchConversations: 'Поиск бесед...',
    selectFolderInstruction: "Выберите папку для просмотра её бесед",
    folderCreated: "Папка успешно создана",
    errorCreatingFolder: "Ошибка создания папки",
    errorLoadingFolders: "Ошибка загрузки папок",
    folderUpdated: "Папка успешно обновлена",
    errorUpdatingFolder: "Ошибка обновления папки",
    folderDeleted: "Папка успешно удалена",
    errorDeletingFolder: "Ошибка удаления папки",
    chatRemovedFromFolders: "Беседа удалена из папки",
    errorRemovingChat: "Ошибка удаления беседы из папки",
    id: "ID",
    labels: "Метки",
    confidence: "Уверенность",
    unknown: "Неизвестный"
  },
  leftPanel: {
    cat1: {
      name: '1. Идентификация и гражданская регистрация',
      children: ['Свидетельства о рождении', 'Национальные удостоверения личности', 'Паспорта', 'Свидетельства о браке и смерти', 'Регистрация избирателей']
    },
    cat2: {
      name: '2. Здравоохранение и социальные услуги',
      children: ['Доступ к общественному здравоохранению', 'Программы вакцинации', 'Медицинская страховка', 'Пособия по инвалидности', 'Социальная помощь и продовольственная поддержка']
    },
    cat3: {
      name: '3. Образование и обучение',
      children: ['Государственные школы и университеты', 'Стипендии и студенческие кредиты', 'Программы обучения для взрослых', 'Онлайн-образовательные ресурсы']
    },
    cat4: {
      name: '4. Трудоустройство и трудовые услуги',
      children: ['Поиск работы и пособия по безработице', 'Защита работников и трудовые права', 'Правила безопасности на рабочем месте', 'Обучение навыкам и стажировки']
    },
    cat5: {
      name: '5. Налоги и доходы',
      children: ['Подача налоговых деклараций и возврат налогов', 'Оплата налогов на имущество', 'Соблюдение налоговых требований для бизнеса', 'Таможенные пошлины и импорт']
    },
    cat6: {
      name: '6. Общественная безопасность и правосудие',
      children: ['Полиция и службы экстренной помощи', 'Суды и юридическая помощь', 'Сообщения о преступлениях', 'Законы о защите прав потребителей']
    },
    cat7: {
      name: '7. Транспорт и мобильность',
      children: ["Водительские права и регистрация транспортных средств", 'Общественный транспорт и инфраструктура', 'Нарушения ПДД и штрафы', 'Программы безопасности дорожного движения']
    },
    cat8: {
      name: '8. Жильё и городское развитие',
      children: ['Государственная жилищная помощь', 'Регистрация недвижимости и земельные записи', 'Жилищные кредиты и субсидии', 'Зонирование и разрешения на строительство']
    },
    cat9: {
      name: '9. Коммунальные услуги и окружающая среда',
      children: ['Водоснабжение и электричество', 'Управление отходами и переработка', 'Экологические нормы', 'Инициативы по возобновляемой энергии']
    },
    cat10: {
      name: '10. Бизнес и торговля',
      children: ['Регистрация и лицензирование бизнеса', 'Торговые правила и разрешения', 'Гранты и стимулы для малого бизнеса', 'Поддержка электронной коммерции и цифрового бизнеса']
    },
    cat11: {
      name: '11. Социальное обеспечение и пенсии',
      children: ['Пенсионные пособия', 'Управление пенсионными фондами', 'Пособия для выживших', 'Пенсии по инвалидности']
    },
    cat12: {
      name: '12. Сообщество и гражданское участие',
      children: ['Голосование и выборы', 'Общественные отзывы и жалобы граждан', 'Волонтёрство и общественные программы', 'Участие в местном самоуправлении']
    }
  },
  settings: {
    title: 'Настройки',
    save: 'Сохранить',
    close: 'Закрыть',
    saveSettings: 'Сохранить настройки',
    savingSettings: "Сохранение ваших настроек...",
    settingsSaved: "Настройки успешно сохранены!",
    saveSuccess: 'Настройки успешно сохранены',
    saveError: 'Ошибка сохранения настроек',
    display: 'Отображение',
    displayLanguage: 'Язык отображения',
    languages: {
      english: 'Английский',
      french: 'Французский',
      swahili: 'Суахили'
    },
    theme: 'Тема',
    themes: {
      light: 'Светлая',
      dark: 'Тёмная',
      system: 'Системная'
    },
    fontSize: 'Размер шрифта',
    notifications: 'Уведомления',
    emailUpdates: 'Обновления по электронной почте',
    soundNotifications: 'Звуковые уведомления',
    accountManagement: 'Управление учётной записью',
    emailAddress: 'Адрес электронной почты',
    emailAddressPlaceholder: 'Ваш адрес электронной почты',
    password: 'Пароль',
    changePassword: 'Изменить пароль',
    resetUserData: 'Сбросить данные пользователя',
    resetUserDataDesc: 'Это удалит все данные вашего профиля и историю чатов.',
    deleteAccount: 'Удалить учётную запись',
    deleteAccountDesc: 'Это навсегда удалит вашу учётную запись и все связанные данные.',
    edit: 'Редактировать',
    standardAccount: 'Стандартная учётная запись',
    confirmEmailChange: 'Подтвердить изменение электронной почты',
    pleaseEnterPassword: 'Пожалуйста, введите ваш пароль',
    cancel: 'Отмена',
    account: {
      title: 'Учётная запись',
      resetDescription: 'Это удалит все данные вашего профиля и историю чатов.',
      confirmReset: 'Вы уверены, что хотите сбросить все ваши данные? Это действие нельзя отменить.',
      resetComplete: 'Ваши данные были сброшены.'
    },
    language: {
      title: 'Язык',
      selectLabel: 'Язык отображения'
    },
    appearance: {
      title: 'Внешний вид',
      lightTheme: 'Светлая',
      darkTheme: 'Тёмная',
      systemTheme: 'Системная'
    },
    confirmDeleteAccount: 'Вы уверены, что хотите удалить вашу учётную запись? Это действие нельзя отменить.',
    confirmAccountDeletion: 'Подтвердить удаление учётной записи',
    accountDeletionWarning: 'Предупреждение: Это действие необратимо. Все ваши данные будут удалены навсегда.',
    deletionReason: 'Причина удаления (необязательно):',
    deletionReasonPlaceholder: 'Почему вы решили удалить учётную запись?',
    enterPasswordConfirm: 'Введите ваш пароль для подтверждения:',
    currentPasswordPlaceholder: 'Ваш текущий пароль',
    deleting: 'Удаление...',
    permanentlyDeleteAccount: 'Удалить учётную запись',
    accountDeletedSuccess: 'Ваша учётная запись успешно удалена.',
    incorrectPassword: 'Неверный пароль',
    accountDeletionFailed: 'Не удалось удалить учётную запись. Пожалуйста, попробуйте снова позже.',
    confirmChange: 'Подтвердить изменение',
    processing: 'Обработка...',
    userDataReset: 'Данные вашего профиля успешно сброшены.',
    failedToResetUserData: 'Не удалось сбросить данные вашего профиля. Пожалуйста, попробуйте снова позже.',
    changingEmailTo: 'Изменение вашего email на',
    will: 'будет',
    logOutSystem: 'Выйти из системы',
    sendVerificationLink: 'Отправить ссылку для подтверждения на ваш новый email',
    requireVerification: 'Требуется подтверждение перед повторным входом',
    checkNewEmailVerification: 'Пожалуйста, проверьте ваш новый email для инструкций по подтверждению.',
    unableToVerifyEmail: 'Не удалось подтвердить email. Пожалуйста, попробуйте снова.',
    emailAlreadyInUse: 'Email уже используется',
    enterValidEmail: 'Пожалуйста, введите действительный адрес электронной почты',
    failedToUpdateEmail: 'Не удалось обновить email. Пожалуйста, попробуйте снова.',
    passwordResetInitiated: 'Ссылка для сброса пароля отправлена на ваш адрес электронной почты.',
    unableToLoadUser: 'Не удалось загрузить информацию о пользователе. Пожалуйста, попробуйте снова.',
    retry: 'Повторить',
    user: 'Пользователь',
    loadingUserInfo: 'Загрузка информации о пользователе...',
    resetUserDataTitle: "Сброс данных пользователя",
    confirmResetUserData: "Вы уверены, что хотите сбросить все данные вашего профиля? Это удалит всю информацию вашего профиля и историю чатов, но сохранит ваши учетные данные.",
    reset: "Сбросить",
    deleteAccountTitle: "Удалить учётную запись"
  },
  userProfile: {
    title: 'Профиль пользователя',
    privacyInfo: "Предоставляя больше информации, вы получите более точные и значимые ответы от чат-бота. Пожалуйста, ознакомьтесь с нашей",
    privacyPolicyLink: 'Политикой конфиденциальности',
    tabComingSoon: 'Эта вкладка находится в разработке и скоро будет доступна.',
    saveSuccess: 'Профиль успешно сохранён',
    loadError: 'Ошибка загрузки данных профиля',
    saveError: 'Ошибка сохранения профиля',
    confirmSaveTitle: "Сохранить профиль",
    confirmSave: "Вы уверены, что хотите сохранить эти изменения?",
    confirmCancel: 'У вас есть несохранённые изменения. Вы уверены, что хотите отменить?',
    confirmLeave: 'Вы уверены, что хотите уйти? Все несохранённые изменения будут потеряны.',
    confirmDiscardChanges: 'Отменить несохранённые изменения?',
    uploadPhoto: 'Загрузить фото',
    uploadFile: 'Загрузить файл',
    photoRequirements: 'Фотография должна быть чёткой, актуальной и показывать ваше лицо полностью',
    biometricRequirements: 'Принимаются только официальные файлы биометрических данных',
    documentUpload: 'Загрузка документа',
    validationTitle: 'Пожалуйста, исправьте следующие ошибки:',
    profileIcon: 'Иконка профиля',
    change: 'Изменить',
    chooseProfileIcon: 'Выбрать иконку профиля',
    presetIcons: 'Предустановленные иконки',
    upload: 'Загрузить',
    initials: 'Инициалы',
    clickToUpload: 'Нажмите для загрузки',
    useThisImage: 'Использовать это изображение',
    useInitials: 'Использовать инициалы',
    tabs: {
      tab1: 'Данные личной идентификации',
      tab2: 'Гражданская регистрация и документация',
      tab3: 'Информация об адресе и проживании',
      tab4: 'Документы удостоверения личности и путешествий',
      tab5: 'Медицинские и здравоохранительные записи',
      tab6: 'Данные о занятости и экономике',
      tab7: 'Образовательные и академические записи',
      tab8: 'Финансовые и налоговые данные',
      tab9: 'Социальное обеспечение и благосостояние',
      tab10: 'Криминальные и юридические записи',
      tab11: 'Транспорт и мобильность',
      tab12: 'Гражданское и политическое участие'
    },
    actions: {
      cancel: 'Отмена',
      save: 'Сохранить профиль',
      previous: 'Предыдущая',
      next: 'Следующая',
      saving: 'Сохранение...'
    },
    fields: {
      fullName: 'Полное имя (включая псевдонимы)',
      dob: 'Дата рождения',
      gender: 'Пол',
      nationality: 'Национальность',
      maritalStatus: 'Семейное положение',
      photograph: 'Фотография',
      biometric: 'Отпечатки пальцев / Биометрические данные',
      birthCert: 'Свидетельство о рождении',
      deathCert: 'Свидетельство о смерти',
      marriageDivorce: 'Записи о браке / разводе',
      adoption: 'Записи об усыновлении',
      citizenship: 'Документы о гражданстве / натурализации',
      immigration: 'История иммиграции и виз',
      currentAddress: 'Текущий адрес проживания',
      previousAddresses: 'Предыдущие адреса',
      postalCode: 'Почтовый индекс',
      country: 'Страна',
      residencyStatus: 'Статус проживания',
      homeOrRental: 'Собственность или детали аренды',
      utilityBills: 'Коммунальные счета, связанные с адресом',
      landRecords: 'Записи о земельной собственности',
      idCard: 'Номер национального удостоверения личности',
      passport: 'Детали паспорта',
      driversLicense: "Водительские права",
      voterId: 'Идентификатор избирателя',
      ssn: 'Номер социального страхования / национального страхования',
      militaryRecords: 'Записи о военной службе',
      medicalHistory: 'Медицинская история и состояния здоровья',
      vaccinations: 'Записи о вакцинации',
      insuranceDetails: 'Детали медицинской страховки',
      disability: 'Статус инвалидности',
      bloodType: 'Группа крови',
      organDonor: 'Статус донора органов',
      prescriptions: 'Рецепты и полученные лечения',
      mentalHealth: 'История психического здоровья',
      eHistory: 'История занятости',
      currentEmployer: 'Детали текущего работодателя',
      workPermits: 'Разрешения на работу и трудовые контракты',
      certifications: 'Профессиональные сертификаты и лицензии',
      unemployment: 'Статус безработицы и полученные пособия',
      tin: 'Идентификационный номер налогоплательщика (TIN)',
      businessAffiliations: 'Собственность бизнеса и связи с компаниями',
      schools: 'Посещённые школы и университеты',
      education: 'Образование',
      degrees: 'Дипломы, степени и сертификаты',
      performance: 'Академическая успеваемость и результаты тестов',
      academicRecords: "Академические записи",
      scholarships: 'Полученные стипендии и финансовая помощь',
      incomeTax: 'Записи о подоходном налоге',
      bankAccounts: 'Банковские и финансовые счета',
      propertyTax: 'Оплаты налога на имущество',
      businessTax: 'Налоговые декларации бизнеса',
      pensionContrib: 'Взносы и снятия с пенсии',
      loanAid: 'Записи о кредитах и государственной помощи',
      pensionStatus: 'Статус пенсии и взносы',
      childcare: 'Поддержка по уходу за детьми',
      foodAssistance: 'Продовольственная помощь / программы благосостояния',
      housingAssistance: 'Жилищная помощь',
      policeRecords: 'Полицейские записи (криминальная история, аресты, обвинения)',
      courtCases: 'История судебных дел',
      finesPenalties: 'Штрафы и наказания',
      paroleProbation: 'Статус условно-досрочного освобождения или испытательного срока',
      citizenshipRevocation: 'Отзыв гражданства (если применимо)',
      vehicleReg: 'Детали регистрации транспортного средства',
      trafficViolations: 'Нарушения ПДД и штрафы',
      licenseHistory: 'История водительских прав и подтверждений',
      publicTransportCard: 'Использование карты общественного транспорта',
      voterRegistration: 'Детали регистрации избирателей',
      electionHistory: 'История участия в выборах',
      partyMembership: 'Членство в политической партии',
      militaryStatus: 'Статус военной службы или призыва',
      publicServiceRoles: 'Роли в государственной службе'
    },
    placeholders: {
      fullName: 'Введите ваше полное законное имя',
      nationality: 'Введите вашу национальность',
      searchCountries: 'Поиск стран...',
      selectCountry: 'Выберите страну',
      searchDisciplines: "Поиск дисциплин...",
      selectDiscipline: "Выберите дисциплину",
      searchDegrees: "Поиск степеней...",
      selectDegree: "Выберите степень"
    },
    validation: {
      nameRequired: 'Полное имя обязательно',
      dobRequired: 'Дата рождения обязательна',
      dobFuture: 'Дата рождения не может быть в будущем',
      requiredField: '{field} обязательно',
      invalidFormat: 'Недействительный формат для {field}',
      futureDate: 'Дата не может быть в будущем',
      invalidSelection: 'Пожалуйста, выберите действительный вариант',
      passwordLength: 'Пароль должен содержать не менее 8 символов',
      matchError: 'Поля не совпадают'
    },
    errors: {
      savingFailed: 'Не удалось сохранить профиль',
      loadingFailed: 'Не удалось загрузить данные профиля',
      invalidForm: 'Пожалуйста, заполните все обязательные поля',
      invalidFileType: 'Недействительный тип файла',
      fileTooLarge: 'Файл слишком большой',
      countryLoadError: 'Ошибка загрузки стран',
      countryUpdateError: 'Ошибка обновления страны'
    },
    notifications: {
      saveSuccess: 'Профиль успешно сохранён',
      saveFailed: 'Не удалось сохранить профиль',
      loadSuccess: 'Профиль успешно загружен',
      loadFailed: 'Не удалось загрузить профиль',
      fieldRequired: 'Это поле обязательно',
      uploadSuccess: 'Файл успешно загружен',
      uploadFailed: 'Не удалось загрузить файл',
      formChanged: 'У вас есть несохранённые изменения',
      sessionExpired: 'Ваша сессия истекла, пожалуйста, войдите снова',
      profileUpdated: 'Ваш профиль обновлён',
      profileIncomplete: 'Ваш профиль неполный'
    },
    instructions: {
      fullNameHelp: 'Введите ваше полное законное имя, как указано в официальных документах',
      dobHelp: 'Введите дату рождения в формате ММ/ДД/ГГГГ',
      uploadPhotoHelp: 'Загрузите недавнюю фотографию. Файл должен быть в формате JPG, PNG или GIF и менее 2 МБ',
      passwordHelp: 'Пароль должен содержать не менее 8 символов, включая одну заглавную букву, одну цифру и один специальный символ',
      documentHelp: 'Принимаемые форматы: PDF, JPG, PNG (максимум 5 МБ)',
      requiredFields: 'Поля, отмеченные *, обязательны',
      selectFromList: 'Пожалуйста, выберите вариант из списка',
      nextTab: 'Перейти к следующему разделу',
      previousTab: 'Вернуться к предыдущему разделу',
      saveInstructions: 'Нажмите Сохранить, чтобы сохранить ваши данные',
      cancelInstructions: 'Нажмите Отмена, чтобы отменить изменения'
    },
    completionStatus: {
      notStarted: 'Не начато',
      inProgress: 'В процессе',
      complete: 'Завершено',
      percentComplete: '{percent}% завершено',
      tabsCompleted: '{completed} из {total} разделов завершено',
      tabComplete: 'Раздел завершён!'
    },
    gender: {
      male: 'Мужской',
      female: 'Женский',
      other: 'Другое',
      preferNot: 'Предпочитаю не указывать'
    },
    maritalStatus: {
      single: 'Холост/Не замужем',
      married: 'Женат/Замужем',
      divorced: 'Разведён/Разведена',
      widowed: 'Вдовец/Вдова',
      other: 'Другое'
    },
    residencyStatuses: {
      citizen: 'Гражданин',
      permanentResident: 'Постоянный резидент',
      temporaryResident: 'Временный резидент',
      other: 'Другое'
    },
    employmentStatuses: {
      employed: 'Занят',
      selfEmployed: 'Самозанятый',
      unemployed: 'Безработный',
      student: 'Студент',
      retired: 'Пенсионер',
      homemaker: 'Домохозяин/Домохозяйка',
      other: 'Другое'
    },
    educationLevels: {
      primary: 'Начальное образование',
      secondary: 'Среднее образование',
      highSchool: 'Средняя школа',
      vocational: 'Профессиональное обучение',
      associate: 'Ассоциативная степень',
      bachelor: 'Бакалавр',
      master: 'Магистр',
      doctoral: 'Докторская степень',
      professional: 'Профессиональная степень',
      other: 'Другое'
    },
    proficiencyLevels: {
      native: 'Носитель языка',
      fluent: 'Свободный',
      advanced: 'Продвинутый',
      intermediate: 'Средний',
      basic: 'Базовый'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Неизвестно'
    },
    languages: {
      english: 'Английский',
      french: 'Французский',
      swahili: 'Суахили',
      arabic: 'Арабский',
      spanish: 'Испанский',
      portuguese: 'Португальский',
      chinese: 'Китайский',
      japanese: 'Японский',
      german: 'Немецкий',
      russian: 'Русский',
      hindi: 'Хинди',
      urdu: 'Урду',
      other: 'Другое'
    },
    yesNo: {
      yes: 'Да',
      no: 'Нет'
    },
    select: 'Пожалуйста, выберите',
    existingFile: 'Существующий файл',
    noMatchingCountries: 'Не найдено соответствующих стран',
    noMatchingDisciplines: "Не найдено соответствующих дисциплин",
    noMatchingDegrees: "Не найдено соответствующих степеней",
    educationOptions: [
      "Бухгалтерский учёт", "Аэрокосмическая инженерия", "Аграрные науки", "Антропология", "Архитектура",
      "История искусств", "Искусственный интеллект", "Астрономия", "Астрофизика", "Биохимия",
      "Биомедицинская инженерия", "Биотехнология", "Бизнес-администрирование", "Химическая инженерия",
      "Химия", "Гражданская инженерия", "Коммуникации", "Компьютерная инженерия", "Компьютерные науки",
      "Управление строительством", "Уголовное правосудие", "Кибербезопасность", "Наука о данных", "Стоматология",
      "Экономика", "Образование", "Электротехника", "Начальное образование", "Английская литература",
      "Экологическая инженерия", "Экологические науки", "Дизайн моды", "Киноведение",
      "Финансы", "Изобразительное искусство", "Пищевая наука", "Криминалистика", "Игровой дизайн",
      "География", "Геология", "Графический дизайн", "Управление здравоохранением", "История",
      "Гостиничный менеджмент", "Человеческие ресурсы", "Промышленный дизайн", "Промышленная инженерия", "Информационные системы",
      "Информационные технологии", "Дизайн интерьеров", "Международный бизнес", "Международные отношения",
      "Журналистика", "Право", "Библиотековедение", "Лингвистика", "Менеджмент", "Маркетинг",
      "Материаловедение", "Математика", "Механическая инженерия", "Медиа-исследования", "Медицина",
      "Метеорология", "Микробиология", "Музыка", "Нанотехнологии", "Сестринское дело", "Питание",
      "Трудотерапия", "Океанография", "Нефтяная инженерия", "Фармацевтика", "Философия",
      "Фотография", "Физическое воспитание", "Физиотерапия", "Физика", "Политология",
      "Психология", "Государственное управление", "Общественное здравоохранение", "Связи с общественностью", "Робототехника",
      "Среднее образование", "Социальная работа", "Социология", "Программная инженерия", "Специальное образование",
      "Спортивный менеджмент", "Статистика", "Системная инженерия", "Театральное искусство", "Туризм",
      "Градостроительство", "Ветеринарная медицина", "Веб-разработка", "Биология дикой природы", "Зоология"
    ],
    degreeOptions: [
      "Ассоциативная степень", "Бакалавр искусств (BA)", "Бакалавр наук (BS)", "Бакалавр инженерии (BEng)",
      "Бакалавр делового администрирования (BBA)", "Бакалавр изобразительных искусств (BFA)", "Бакалавр образования (BEd)",
      "Бакалавр медицины (MBBS)", "Бакалавр права (LLB)", "Магистр искусств (MA)", "Магистр наук (MS)",
      "Магистр делового администрирования (MBA)", "Магистр инженерии (MEng)", "Магистр изобразительных искусств (MFA)",
      "Магистр образования (MEd)", "Магистр права (LLM)", "Магистр общественного здравоохранения (MPH)",
      "Доктор философии (PhD)", "Доктор медицины (MD)", "Доктор образования (EdD)",
      "Доктор делового администрирования (DBA)", "Доктор юриспруденции (JD)", "Профессиональный диплом",
      "Технический диплом", "Профессиональный сертификат", "Сертификат магистра", "Диплом магистра", "Постдокторантура"
    ],
    aria: {
      tabList: 'Разделы формы профиля',
      nextButton: 'Перейти к следующему разделу',
      prevButton: 'Вернуться к предыдущему разделу',
      closeButton: 'Закрыть форму профиля',
      saveButton: 'Сохранить данные профиля',
      requiredField: 'Обязательное поле',
      dropdownSelect: 'Выберите вариант'
    }
  },
  chatbot: {
    placeholder: 'Введите ваш запрос здесь...',
    sendButton: 'Отправить',
    fileReceived: 'Файл успешно получен.',
    fileUploadError: 'Ошибка загрузки файла.',
    processingError: 'Ошибка обработки вашего запроса.',
    welcomeMessage: 'Добро пожаловать! Чем я могу помочь вам с государственными услугами Кении сегодня?',
    attachFile: 'Прикрепить файл',
    fileTooLarge: 'Файл слишком большой. Максимальный размер {maxSize}.',
    saveChat: 'Сохранить чат',
    chatSaved: 'Чат сохранён',
    chatTitle: 'Название чата',
    chatTitlePlaceholder: 'Введите название для этого чата',
    selectFolder: 'Выберите папку',
    newChat: 'Новый чат',
    clearContext: 'Очистить контекст и начать новый разговор',
    unsavedChanges: 'У вас есть несохранённые изменения. Вы уверены, что хотите начать новый чат?',
    whatCanIHelp: "Чем я могу помочь вам сегодня?",
    justChat: "Просто чат",
    queryContext: "Контекст запроса",
    contextAdded: 'Контекст добавлен к вашему запросу',
    contextRemoved: 'Контекст удалён из вашего запроса',
    sessionUpdated: 'Сессия обновлена',
    newChatStarted: 'Начата новая беседа',
    loadError: 'Не удалось загрузить историю чата',
    responsePrefix: "Я получил ваше сообщение",
    withContext: "с контекстом",
    conversationLoaded: "Беседа успешно загружена!",
    saveConfirmTitle: "Сохранить существующую беседу",
    saveConfirmMessage: "Сохранить существующую беседу?",
    loadConfirmTitle: "Загрузить существующую беседу",
    loadConfirmMessage: "У вас есть несохранённые изменения. Хотите ли вы отменить их и загрузить выбранную беседу или сначала сохранить текущую беседу?",
    loadAndDiscard: "Загрузить и отменить",
    saveAndLoad: "Сохранить и загрузить",
    saveAndStartNew: "Сохранить и начать новый",
    discardAndStartNew: "Отменить и начать новый",
    newChatTitle: "Начать новый чат",
    exportChat: 'Экспортировать чат',
    exportFilename: 'Имя файла',
    exportFilenamePlaceholder: 'Введите имя файла',
    exportButton: 'Экспортировать',
    exportSuccess: 'Чат успешно экспортирован',
    exportError: 'Не удалось экспортировать чат. Пожалуйста, попробуйте снова.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Получить ID",
    payTaxes: "Оплатить налоги",
    startBusiness: "Начать бизнес",
    findHealthcare: "Здравоохранение",
    educationServices: "Образование",
    transportLicenses: "Транспорт",
    housingPrograms: "Жильё",
    findJobs: "Работа",
    justChat: "Просто чат",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "Я хотел бы поболтать о государственных услугах",
    applyForIDUserPrompt: "Мне нужна информация о том, как подать заявку на национальное удостоверение личности",
    payTaxesUserPrompt: "Каков процесс оплаты налогов онлайн?",
    startBusinessUserPrompt: "Проведите меня через шаги регистрации нового бизнеса",
    findHealthcareUserPrompt: "Где я могу найти информацию об общественных медицинских услугах?",
    educationServicesUserPrompt: "Какие образовательные услуги доступны для моих детей?",
    transportLicensesUserPrompt: "Как мне продлить водительские права?",
    housingProgramsUserPrompt: "Расскажите о доступных жилищных программах в Кении",
    findJobsUserPrompt: "Какие государственные вакансии доступны в настоящее время?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Отмена',
    create: 'Создать',
    save: 'Сохранить',
    move: 'Переместить',
    delete: 'Удалить',
    // --- NEW KEYS ADDED ---
    ok: 'ОК',
    ingest: 'Обработать',
    retract: 'Изъять',
    loading: 'Загрузка...',
    refresh: 'Обновить'
  },
  feedback: {
    title: 'Отзыв',
    button: 'Отзыв',
    positive: 'Положительный отзыв',
    negative: 'Отрицательный отзыв',
    promptText: 'Был ли этот ответ полезен?',
    placeholder: 'Дополнительные комментарии...',
    submit: 'Отправить отзыв',
    close: 'Отмена',
    thankYouMessage: 'Спасибо за ваш отзыв!',
    submitting: 'Отправка...',
    error: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
    success: 'Спасибо за ваш отзыв!'
  },
  responseRating: {
    title: 'Помогите нам улучшиться',
    note: 'Ваш отзыв будет использован для лучшей настройки чат-бота и улучшения ответов со временем.',
    chatbotResponse: 'Ответ чат-бота:',
    ratingLabels: {
      1: 'Бесполезно',
      2: 'Слегка полезно',
      3: 'Умеренно полезно',
      4: 'Очень полезно',
      5: 'Изменяет жизнь'
    },
    additionalComments: 'Дополнительные комментарии...',
    submit: 'Отправить',
    cancel: 'Отмена'
  },
  upload: {
    alt: 'Загрузить'
  },
  details: {
    loading: 'Загрузка сведений о файле...',
    title: 'Сведения о файле',
    close: 'Закрыть',
    fileName: 'Имя файла',
    author: 'Автор',
    labels: 'Метки',
    selectAll: 'Выбрать все',
    loadingLabels: 'Загрузка меток...',
    status: 'Статус',
    fileId: 'ID файла',
    fileType: 'Тип файла',
    viewFile: 'Просмотреть файл',
    visitLink: 'Перейти по внешней ссылке',
    openFile: 'Открыть файл в новой вкладке',
    fileSize: 'Размер файла',
    uploadDate: 'Дата загрузки',
    hash: 'Хеш SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Детали",
      ingestionLog: "Журнал обработки"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Действия по остановке:",
      killDocument: "Остановить этот документ",
      killProcess: "Остановить процесс обработки",
      timestamp: "Временная метка",
      level: "Уровень",
      stage: "Этап",
      message: "Сообщение",
      loadingLogs: "Загрузка журналов...",
      noLogs: "Журналы не найдены."
    },
    buttons: {
      saveMetadata: 'Сохранить метаданные',
      retract: 'Изъять',
      ingest: 'Обработать'
    },
    notifications: {
      loadError: 'Не удалось загрузить сведения о файле.',
      validationError: 'Имя файла и автор обязательны для заполнения.',
      saveSuccess: 'Метаданные успешно обновлены.',
      saveError: 'Не удалось сохранить метаданные.',
      tokenError: 'Токен аутентификации не найден в данных пользователя.',
      viewError: 'Не удалось загрузить файл для просмотра.',
      ingestSuccess: 'Файл успешно добавлен в очередь на обработку.',
      ingestError: 'Не удалось запустить процесс обработки.',
      retractSuccess: 'Файл успешно изъят.',
      retractError: 'Не удалось изъять файл.',
      deleteSuccess: 'Файл успешно удален.',
      deleteError: 'Не удалось удалить файл.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Пожалуйста, выберите хотя бы одну метку перед обработкой.",
      ingestSaving: "Сохранение метаданных перед обработкой...",
      ingestSaveFailed: "Не удалось сохранить метаданные. Обработка отменена.",
      logError: "Не удалось получить журналы обработки.",
      killDocSent: "Запрос на остановку этого документа отправлен.",
      killProcSent: "Запрос на остановку процесса обработки отправлен."
    },
    confirm: {
      ingest: 'Вы уверены, что хотите обработать этот файл? Это запустит конвейер обработки данных.',
      retract: 'Вы уверены, что хотите изъять этот файл?',
      delete: 'Вы уверены, что хотите безвозвратно удалить этот файл? Это действие нельзя отменить.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Подтвердить обработку",
      retractTitle: "Подтвердить изъятие",
      deleteTitle: "Подтвердить удаление",
      killDocTitle: "Остановить обработку документа",
      killDoc: "Вы уверены, что хотите остановить задачу обработки для ЭТОГО документа? Процесс попытается выполнить безопасный откат.",
      killProcTitle: "Остановить ВЕСЬ процесс обработки",
      killProc: "ВНИМАНИЕ: Это остановит всю службу обработки в бэкенде, что затронет ВСЕ файлы, находящиеся в данный момент в обработке. Вы абсолютно уверены?"
    }
  },
  uploadDialog: {
    title: 'Загрузить файлы',
    dropzone: 'Перетащите файлы сюда или нажмите для выбора',
    allowedTypesLabel: 'Разрешенные типы:',
    buttonUpload: 'Загрузить {count} файл(ов)', // Pluralization needs adjustment
    remove: 'Удалить',
    uploading: 'Загрузка...',
    notifications: {
      dropError: 'Можно перетаскивать только файлы. Убедитесь, что вы перетаскиваете действительный файл с компьютера.',
      typeNotAllowed: 'Тип файла "{extension}" не разрешен.',
      shortcutUnsupported: 'Файлы ярлыков (.url) не поддерживаются. Пожалуйста, перетащите сам файл.',
      duplicate: 'Файл "{fileName}" уже добавлен.',
      uploadSuccess: 'Файл {fileName} успешно загружен',
      uploadFailed: 'Не удалось загрузить файл {fileName}.'
    }
  }
}